import { useSuspenseQueries } from '@tanstack/react-query';
import { maxEndppointOIDCProvidersQueryOptions } from '#api/endpoint-oidc-providers.queries.ts';
import { adminOIDCProvidersQueryOptions } from '#api/oidc-providers.queries.ts';

export function useSuspenseAllOIDCProvidersQuery() {
  return useSuspenseQueries({
    queries: [adminOIDCProvidersQueryOptions, maxEndppointOIDCProvidersQueryOptions],
    combine: (results) => {
      const [adminResults, endpointResults] = results;
      return {
        data: { admin: adminResults.data, endpoint: endpointResults.data },
      };
    },
  });
}
